import axios from 'axios'
import { SdgCompilance } from 'src/core/models'


export async function getSdgCompliancesListAPI(): Promise<SdgCompilance[]> {
  const url = '/api/v1/sdg_compliance/?page_size=9999'
  const { data } = await axios.get<{count: number, next: string, previous: string, results: SdgCompilance[]}>(url)
  return data?.results
}
